import React from 'react';
import cx from 'classnames';
import styles from './MadeWithMarvel.module.css';
import * as marvelURL from '../constants/marvelURL';
export default function MadeWithMarvel() {
    return (React.createElement("a", { className: cx(styles.madeWithMarvel, 'zi-500'), href: marvelURL.HOMEPAGE, target: "_parent" }, "Made with Marvel"));
}
